import Log from 'services/Log';
import SalesChannel from 'services/SalesChannel'
import LoginService from 'services/Login'

const create = (item, skuData = null) => {
    if(!skuData) skuData = item.skuData;
    if (item.promotions && skuData) {
        const commertialOffer = item.sellers && item.sellers[0] ? item.sellers[0].commertialOffer : false;

        if(commertialOffer && !(commertialOffer.Price || commertialOffer.ListPrice)){
            return [];
        }

        let promotions = _getProgressivePromotions(item.promotions, item);

        Log.debug('Item:', item, 'skuData:',skuData, 'Promotions:',promotions);

        promotions = promotions.map((promotion) => {
            const salesChannel = SalesChannel.getSalesChannel();
            const idsSalesChannelExclusive = promotion.idsSalesChannelExclusive;
            const idsSalesChannel = promotion.idsSalesChannel;
            let isPriceView = true;

            if(promotion.idsSalesChannel.length > 0 && ((!idsSalesChannelExclusive && idsSalesChannel.indexOf(salesChannel.toString()) === -1) || (idsSalesChannelExclusive && idsSalesChannel.indexOf(salesChannel.toString()) !== -1)) ){
                return false;
            }

            if (promotion.value === 0) {
                return false;
            }

            if (!promotion.quantity) {
                promotion.quantity = 1;
            }

            if (typeof skuData.unit_multiplier_un !== 'number') {
                skuData.unit_multiplier_un = 1;
            }

            if (typeof skuData.unit_multiplier !== 'number') {
                skuData.unit_multiplier = 1;
            }

            let promototionObject = null;
            let price = parseFloat(promotion.value);

            const bestPrice = commertialOffer ? commertialOffer.Price : item.bestPrice;
            let listPrice = commertialOffer ? (commertialOffer.PriceWithoutDiscount || commertialOffer.ListPrice) : item.price / 100;
            listPrice = (promotion.cumulative && promotion.promotionType !== 'for_the_price_of') ? (bestPrice || listPrice) : (listPrice || bestPrice);

            if (promotion.discountType === 'percentual') {
                price = parseFloat(((listPrice * item.unitMultiplier) / 100) * (price < 100 ? (100 - price) : (price / promotion.quantity)));
            }

            switch (promotion.promotionType) {
                case 'for_the_price_of': {
                    let title = `${promotion.quantity}X`;

                    let subtitle = null;

                    if(promotion.discountType === 'percentual'){
                        if (promotion.quantity === promotion.quantityAffected) {
                            const quantityAffected = Math.round(promotion.quantity * (price / (listPrice * skuData.unit_multiplier)))
                            title = title + quantityAffected;
                            price = price * promotion.quantity;

                            if(promotion.quantity === quantityAffected){
                                return false;
                            }
                        } else {
                            const descQuantityArray = ['', 'ra', 'da', 'ra', 'ta', 'ta', 'ta', 'ma', 'va', 'na', 'ma'];
                            const descQuantity = descQuantityArray[promotion.quantity] || '';
                            title = parseInt(promotion.value) + '% ' + ' ' + promotion.quantity + descQuantity + ' unid.';
                            price = price + (listPrice * skuData.unit_multiplier) * (promotion.quantity - 1);
                        }

                        isPriceView = false;

                    } else{
                        price = price * promotion.quantity;
                    }

                    var pricePpum = price / (skuData.unit_multiplier_un * promotion.quantity);

                    promototionObject = {
                        titleFlag: title.toLowerCase(),
                        classFlag: 'pack',
                        type: promotion.promotionType,
                        title: title,
                        price: Math.round(price),
                        pricePpum: Math.round(pricePpum),
                        pricePpumOrigin: pricePpum,
                        subtitle: subtitle
                    };
                    break;
                }
                case 'regular': {
                    const textDiscount = promotion.tcenco ? 'T. Cencosud Scotiabank' : 'Otro medio de pago';
                    promototionObject = {
                        titleFlag: promotion.discountType !== 'percentual' ? 'Oferta' : parseInt(promotion.value) + "%",
                        classFlag: promotion.discountType !== 'percentual' ? 'oferta' : 'discount',
                        type: promotion.promotionType,
                        title: promotion.discountType === 'percentual' ? parseInt(promotion.value) + '%' : textDiscount,
                        price: Math.round(price),
                        pricePpum: Math.round(price / skuData.unit_multiplier_un),
                        pricePpumOrigin: price / skuData.unit_multiplier_un
                    };
                    break;
                }
            }

            if (promototionObject) {
                promototionObject.isPromotion = true;
                promototionObject.measurementUnit = skuData.measurement_unit_un || item.measurementUnit;
                promototionObject.tcenco = promotion.tcenco;
                promototionObject.cencoPrime = promotion.cencoPrime;
                promototionObject.minQuantity = parseInt(promotion.quantity);
                promototionObject.end = new Date(promotion.end);
                promototionObject.description = promotion.description;
                promototionObject.short_description = promotion.short_description;
                promototionObject.isPriceView = isPriceView;
                promototionObject.id = promotion.id;
                promototionObject.isMoreProducts = promotion.isMoreProducts;
                promototionObject.isPercent = promotion.discountType === 'percentual';

                if (!promototionObject.subtitle) {
                    promototionObject.subtitle = promototionObject.tcenco ? 'T. Cencosud Scotiabank' : 'Otro medio de pago';
                }
            }

            return promototionObject;
        }).filter(Boolean);

        return _verifyPromotions(promotions, item);
    }

    return [];
}

const _excludePromotions =  (productId, skuId, brand, categoriesIds, collections, promotion) => {
    let isExcluded = false;

    if(!promotion) return false;

    promotion.excludeCollections.map(collection => {
        if(!(collection && collection.id)) return false;

        if(collections.indexOf(collection.id) !== -1) isExcluded = true;
    });

    if(promotion.excludeProducts.length > 0 && promotion.excludeProducts.indexOf(productId) !== -1) isExcluded = true;
    if(promotion.excludeSkus.length > 0 && promotion.excludeSkus.indexOf(skuId) !== -1) isExcluded = true;
    if(promotion.excludeBrands.length > 0 && promotion.excludeBrands.indexOf(brand) !== -1) isExcluded = true;

    if(promotion.excludeCategories.length > 0){
        categoriesIds.map(id => {
            if(promotion.excludeCategories.indexOf(id) !== -1) isExcluded = true;
        });
    }

    return isExcluded;
}

const setProductPromotions = (product, objectPromotions) => {
    if (objectPromotions) {
        const haveProducts = objectPromotions.products && Object.keys(objectPromotions.products).length > 0;
        const haveSku = objectPromotions.skus && Object.keys(objectPromotions.skus).length > 0;
        const haveBrands = objectPromotions.brands && Object.keys(objectPromotions.brands).length > 0;
        const haveCategories = objectPromotions.categories && Object.keys(objectPromotions.categories).length > 0;
        const haveCollections = objectPromotions.collections && Object.keys(objectPromotions.collections).length > 0;

        product.items.map((item) => {
            let productPromotions = [];
            let moreProductPromotions = [];
            let categoriesIds = [];

            if(haveProducts && objectPromotions.products[product.productId]){
                productPromotions = productPromotions.concat(objectPromotions.products[product.productId]);
            }

            if(haveSku && objectPromotions.skus[item.itemId]){
                productPromotions = productPromotions.concat(objectPromotions.skus[item.itemId]);
            }

            if(haveBrands && objectPromotions.brands[product.brand]){
                moreProductPromotions = moreProductPromotions.concat(objectPromotions.brands[product.brand]);
            }

            if(haveCategories && product.categoriesIds[0]){
                categoriesIds = product.categoriesIds[0].split('/').filter(Boolean);

                categoriesIds.map(id => {
                    if(objectPromotions.categories[id] && objectPromotions.categories[id].length > 0){
                        moreProductPromotions = moreProductPromotions.concat(objectPromotions.categories[id]);
                    }
                });
            }

            if (haveCollections) {
                for (var key in product.productClusters) {
                    if(objectPromotions.collections[key] && objectPromotions.collections[key].length > 0){
                        moreProductPromotions = moreProductPromotions.concat(objectPromotions.collections[key]);
                    }
                }
            }

            if(objectPromotions.allProducts){
                moreProductPromotions = moreProductPromotions.concat(objectPromotions.allProducts);
            }

            item.promotions = [];

            if (productPromotions.length > 0) {
                item.promotions = item.promotions.concat(productPromotions.map(id => {
                    let promotion = objectPromotions.promotions[id];
                    if(_excludePromotions(product.productId, item.itemId, product.brand, categoriesIds, product.productClusters, promotion)) return false;
                    promotion.id = id;
                    promotion.isMoreProducts = false;
                    return promotion && new Date() >= new Date(promotion.start) && new Date() < new Date(promotion.end) ? promotion : false;
                }).filter(Boolean));
            }

            if (moreProductPromotions.length > 0) {
                item.promotions = item.promotions.concat(moreProductPromotions.map(id => {
                    let promotion = objectPromotions.promotions[id];
                    if(_excludePromotions(product.productId, item.itemId, product.brand, categoriesIds, product.productClusters, promotion)) return false;
                    promotion.id = id;
                    promotion.isMoreProducts = true;
                    return promotion && new Date() >= new Date(promotion.start) && new Date() < new Date(promotion.end) ? promotion : false;
                }).filter(Boolean));
            }
        });
    }

    return product;
}

const setItemPromotions = (item, objectPromotions) => {
    if (objectPromotions) {
        const haveProducts = objectPromotions.products && Object.keys(objectPromotions.products).length > 0;
        const haveSku = objectPromotions.skus && Object.keys(objectPromotions.skus).length > 0;
        const haveBrands = objectPromotions.brands && Object.keys(objectPromotions.brands).length > 0;
        const haveCategories = objectPromotions.categories && Object.keys(objectPromotions.categories).length > 0;
        const haveCollections = objectPromotions.collections && Object.keys(objectPromotions.collections).length > 0;

        let productPromotions = [];
        let moreProductPromotions = [];
        let categoriesIds = [];

        if(haveProducts && objectPromotions.products[item.productId]){
            productPromotions = productPromotions.concat(objectPromotions.products[item.productId]);
        }

        if(haveSku && objectPromotions.skus[item.id]){
            productPromotions = productPromotions.concat(objectPromotions.skus[item.id]);
        }

        const brand = item.additionalInfo.brandName;
        if(haveBrands && objectPromotions.brands[brand]){
            moreProductPromotions = moreProductPromotions.concat(objectPromotions.brands[brand]);
        }

        if(haveCategories && item.productCategoryIds){
            categoriesIds = item.productCategoryIds.split('/').filter(Boolean);

            categoriesIds.map(id => {
                if(objectPromotions.categories[id] && objectPromotions.categories[id].length > 0){
                    moreProductPromotions = moreProductPromotions.concat(objectPromotions.categories[id]);
                }
            });
        }

        if (haveCollections) {
            for (var key in item.productClusters) {
                if(objectPromotions.collections[key] && objectPromotions.collections[key].length > 0){
                    moreProductPromotions = moreProductPromotions.concat(objectPromotions.collections[key]);
                }
            }
        }

        if(objectPromotions.allProducts){
            moreProductPromotions = moreProductPromotions.concat(objectPromotions.allProducts);
        }

        item.promotions = [];

        if (productPromotions.length > 0) {
            item.promotions = item.promotions.concat(productPromotions.map(id => {
                let promotion = objectPromotions.promotions[id];
                if(_excludePromotions(item.productId, item.id, brand, categoriesIds, item.productClusters, promotion)) return false;
                promotion.id = id;
                promotion.isMoreProducts = false;
                return promotion && new Date() >= new Date(promotion.start) && new Date() < new Date(promotion.end) ? promotion : false;
            }).filter(Boolean));
        }

        if (moreProductPromotions.length > 0) {
            item.promotions = item.promotions.concat(moreProductPromotions.map(id => {
                let promotion = objectPromotions.promotions[id];
                if(_excludePromotions(item.productId, item.id, brand, categoriesIds, item.productClusters, promotion)) return false;
                promotion.id = id;
                promotion.isMoreProducts = true;
                return promotion && new Date() >= new Date(promotion.start) && new Date() < new Date(promotion.end) ? promotion : false;
            }).filter(Boolean));
        }
    }

    return item;
}

const _getProgressivePromotions = (promotions, item) => {
    let newPromotions = [];

    const commertialOffer = item.sellers && item.sellers[0] ? item.sellers[0].commertialOffer : false;
    const listPrice = commertialOffer ? (commertialOffer.PriceWithoutDiscount || commertialOffer.ListPrice) : item.price / 100;

    promotions.map(promotion => {
        if (promotion.promotionType === 'progressive') {
            promotion.percentualDiscountValueList.map(percentual => {
                let newPromotion = Object.assign({}, promotion);
                newPromotion.quantity = percentual.quantity;
                newPromotion.value = parseInt((listPrice * item.unitMultiplier / 100) * (100 - percentual.percent));
                newPromotion.promotionType = 'for_the_price_of';
                newPromotions.push(newPromotion);
            });
            return null;
        }
        return promotion;
    }).filter(Boolean);

    return promotions.concat(newPromotions);
}

const _verifyPromotions = (data, item = null) => {
    let promotionsFiltered = {};
    const userIsPrime = LoginService.isPrime();

    Log.debug('call verifyPromotions: ', data);

    const promotions = data.sort((a, b) => {
        if (a.end > b.end) {
            return -1;
        } else if (a.end < b.end) {
            return 1;
        } else {
            return 0;
        }
    });

    promotions.map(promotion => {
        const key  = promotion.tcenco ? 'tcenco' : (!userIsPrime && promotion.cencoPrime ? 'prime' : 'tmp');
        const oldPromotion = promotionsFiltered[key];

        if (!oldPromotion || (promotion.pricePpumOrigin && promotion.pricePpumOrigin < oldPromotion.pricePpumOrigin)) {
            promotionsFiltered[key] = promotion;
        }
    });

    let results = [];

    for (let key in promotionsFiltered) {
        results.push(promotionsFiltered[key]);
    }

    results = results.filter(promotion => {
        if (promotion.tcenco && promotion.pricePpumOrigin) {
            const similarPromotion = promotionsFiltered['tmp'];

            return similarPromotion ? (promotion.minQuantity !== similarPromotion.minQuantity || promotion.pricePpumOrigin < similarPromotion.pricePpumOrigin) : true;
        }

        if (!promotion.cencoPrime && promotion.type === 'regular' && !(item && item.prices && item.prices.old !== item.prices.regular)) return false;

        return !(item && item.prices && promotion.pricePpumOrigin && item.prices.regularPpum < promotion.pricePpumOrigin - 33);
    });

    results = results.filter(promotion => !promotion.cencoPrime || results.length === 1);

    Log.debug('return verifyPromotions: ', results);

    if(item){
        results.forEach(promotion => {
            if(promotion.tcenco){
                item.promotionCat = true;
            }
        });
    }

    return results;
}

const getPromotionsApplied = (product) => {
    if (!product.items) {
        return [];
    }
    let priceItem = [];
    const userIsPrime = LoginService.isPrime();
    const item = product.items[0];
    const skuData = (product && product.SkuData && product.SkuData[item.itemId]) ? product.SkuData[item.itemId] : {};
    const promotions = PromotionFactory.create(item, skuData);

    const isOffer = promotions.filter(promotion => {
        return promotion.type === 'regular' && !promotion.tcenco && (!promotion.cencoPrime || userIsPrime)
    }).length > 0;

    let productPrice = item.prices;

    if (!productPrice) {
        productPrice = {
            old: 0,
            oldPpum: 0,
            regular: 0,
            regularPpum: 0
        }
    }

    let unitMeasurement = '';
    if(item.measurementUnit === 'kg' && item.unitMultiplier < 1){
        unitMeasurement = (item.unitMultiplier * 1000) + ' g';
    } else if(item.measurementUnit === 'kg' && item.unitMultiplier > 1){
        unitMeasurement = (item.unitMultiplier + ' ' + item.measurementUnit);
    } else {
        unitMeasurement = ((item.unitMultiplier || 1) + ' ' + (item.measurementUnit || 'un'));
    }

    if (!isOffer && productPrice.old && (productPrice.regular < productPrice.old)) {
        priceItem.push({
            title: false,
            type: 'regular',
            subtitle: false,
            oldPrice: productPrice.old,
            oldPpum: productPrice.oldPpum,
            price: productPrice.regular,
            pricePpum: productPrice.regularPpum,
            measurementUnit: skuData ? skuData.measurement_unit_un : 0,
            isPriceView: true,
            unitMeasurement: unitMeasurement
        });
    } else {
        priceItem.push({
            title: false,
            type: '',
            subtitle: false,
            oldPrice: isOffer ? productPrice.old : false,
            price: isOffer ? false : productPrice.regular,
            oldPpum: productPrice.oldPpum,
            pricePpum: isOffer ? productPrice.oldPpum : productPrice.regularPpum,
            measurementUnit: skuData ? skuData.measurement_unit_un : 0,
            isPriceView: true,
            unitMeasurement: unitMeasurement
        });
    }

    priceItem = priceItem.concat(promotions);
    return priceItem;
}

const PromotionFactory = {
    create,
    setProductPromotions,
    setItemPromotions,
    getPromotionsApplied
}

export default PromotionFactory
